import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { pasangPelaporGalat } from "@/lib/laporGalat";

// PR log galat: galat browser pembeli dikirim ke server (tanpa skrip inline, tanpa layanan pihak ketiga)
pasangPelaporGalat();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Layar awal dilepas (langsung, tanpa fade) setelah React menggambar frame pertama
// supaya tidak pernah bertumpuk dengan isi halaman.
requestAnimationFrame(() => requestAnimationFrame(() => {
  const splash = document.getElementById("hs-splash");
  if (splash) splash.remove();
}));
